// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"507":"22901b7a","791":"5ce7c793"}[chunkId] + ".chunk.js";
};